
import { Component, Vue, Prop, toNative } from 'vue-facing-decorator';
import { StoreHelper } from '@/store/StoreHelper';
import { LatestNewsRequestInfo } from '@/entities/Application/LatestNewsRequestInfo';
import loading from '@/components/Common/loading.vue';
import { FetchData, Store } from '@/main';
@Component({
  components: {
    loading,
  },
})
class LatestNews extends Vue {
  @Prop() private showModalPopup?: boolean;
  @Prop() private borderColor?: string;
  private localBorderColor = '';
  private localShowModalPopup?: boolean = false;
  private showLoading = false;
  private newsContent = '';
  private newsTitle = '';
  private newsImgUrl = '';
  private Cancel() {
    this.$emit('close-popup', false);
  }
  private GetLatestNews() {
    const storeHelper: StoreHelper = new StoreHelper(Store);
    const latestNewsInfo: LatestNewsRequestInfo = storeHelper.GetLatestNewsFromStore();
    if (latestNewsInfo) {
      this.newsTitle = latestNewsInfo.Title;
      this.newsImgUrl = latestNewsInfo.ImageUrl;
      this.newsContent = latestNewsInfo.Description;
      this.localShowModalPopup = this.showModalPopup;
    } else {
      this.showLoading = true;
      FetchData('/Common/GetLatestNewsCookieInfo', JSON.stringify({
        filter: '',
      }))
        .then((response) => {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          const storeHelper: StoreHelper = new StoreHelper(Store);
          if (response.isPublished === true) {
            this.newsContent = response.description;
            this.newsTitle = response.title;
            this.newsImgUrl = response.imgUrl;
            const latestNews: LatestNewsRequestInfo = new LatestNewsRequestInfo(
              Boolean(response.isPublished),
              this.newsTitle,
              this.newsContent,
              this.newsImgUrl,
            );
            storeHelper.SaveLatestNewsToStore(latestNews);
            this.localShowModalPopup = this.showModalPopup;
          } else {
            this.localShowModalPopup = false;
          }
          this.showLoading = false;
        })
        .catch(() => {
          this.showLoading = false;
        });
    }
  }
  private mounted() {
    this.localBorderColor = this.borderColor!;
    this.GetLatestNews();
  }
}
export default toNative(LatestNews);
